// import getGroupId from './get-group-id';

'use strict';

exports.__esModule = true;
exports['default'] = {
  background: {
    image: '/background-blurred.jpg',
    size: 'cover'
  },
  props: {
    'tournamentId': ':tournamentId',
    'groupRef': ':groupRef',
    'teamId': ':teamId'
  },
  title: function title(getState, props) {
    var _getState = getState();

    var tournaments = _getState.tournaments;
    var teams = _getState.teams;

    var club = tournaments.clubsById[props.tournamentId];
    // TODO re-enable when we fix the title and background being compiled when injected into the
    // panel, otherwise we get a missing ref for getGroupId because this function makes it into our
    // state.
    // const group = state.tournaments.groupsById[getGroupId(props.tournamentId, props.groupRef)];
    var group = tournaments.groupsById[props.tournamentId + '-' + props.groupRef];

    var team = teams.byId[props.teamId];

    return team.name + ' | ' + club.name + ' ' + group.name;
  },
  type: 'Team'
};
module.exports = exports['default'];